<template>
    <div>
        <div
			:style="`
				width: 100%;
				height: ${height ? (height < 100 ? 100 : height) : 100}px;
				display: inline-block;
				position: relative;
			`">
			<pre
				style="width: 100%; height: 100%"
				:id="'ace_editor-' + id"></pre>
		</div>
    </div>

</template>

<script>
	import "../../public/js/ace-builds/src-min-noconflict/ace.js";
    import "../../public/js/ace-builds/src-min-noconflict/ext-language_tools.js";
    import beautify from 'js-beautify'

    import uniqueId from "lodash.uniqueid";

    import store from "../store";

	var clone = require("clone");

    export default {
        name: "ace_editor",
        props: {
            code: {
				default: ""
            },
            height: {
                default: 0
            },
            mode: {
                default: "javascript"
            }
        },
        data: function () {
            return {				
                id: uniqueId(""),
                _code : ""
            };
		},
        watch: {
            code() {
                if (this.code != this._code)
                {
                    this.ace_editor.setValue(this.code);
                    this.ace_editor.clearSelection();
                }
            }
        },
		methods: {
            save()
            {
                return this._code;
            },
            load(code)
            {
                this.ace_editor.setValue(code);
                this.ace_editor.clearSelection();
            }
        },
		mounted: function () {
            console.log("mounted ace editor");

            var self = this;

            var ace_editor = ace.edit("ace_editor-" + this.id);
            this.ace_editor = ace_editor;
			ace_editor.session.setMode("ace/mode/" + this.mode);
			var theme = "chrome";
			if (
				store &&
				store.state &&
				store.state.style &&
				store.state.style.theme &&
				store.state.style.theme.code
			)
				theme = store.state.style.theme.code;
			ace_editor.setTheme("ace/theme/" + theme);
			// enable autocompletion and snippets
			ace_editor.setOptions({
				enableBasicAutocompletion: true,
				enableSnippets: true,
				enableLiveAutocompletion: true,
                wrap: true
            });
            ace_editor.session.on("change", function (delta) {
                //console.log(self.data)
                self._code = ace_editor.getValue();
                self.$emit("update", self._code);
            });

            if (this.code)
            {
                this.ace_editor.setValue(this.code);
                this.ace_editor.clearSelection();
    		}
        },
    }

</script>